<template>
  <CustomAccordionButton class="component-training" :collapseId="id">
    <template slot="header"
      ><div class="title T16 color-primary maiusculo">
        {{ $props.title }}
      </div></template
    >
    <template slot="content">
      <hr />
      <Period :item="$props.item" />
      <div v-for="(item, index) in $props.steps" :key="id + index">
        <hr />
        <div>
          <div
            class="align-items-center step-title T16"
            @click="() => onClick(item)"
            :class="getClassToPending(item, $props.steps[index - 1])"
          >
            <div>
              <img
                class="custom-img"
                :src="getPathUrl(item, $props.steps[index - 1])"
              />
            </div>
            <div
              class="title align-items-center"
              :class="
                isDisabled(item, $props.steps[index - 1]) && 'custom-disabled'
              "
            >
              {{ item.title }}
            </div>
            <div class="ml-auto icon-download-pdf" v-if="onCheckDownload(item)">
              <img
                title="Fazer download do material"
                id="download-pdf-icon"
                class="custom-img"
                :class="
                  isDisabled(item, $props.steps[index - 1]) && 'custom-disabled'
                "
                @click="
                  !isDisabled(item, $props.steps[index - 1]) &&
                    onDownloadPrincipal(item)
                "
                :src="resolve_path_url('download-pencil-outline.svg')"
              />
            </div>
            <div
              class="ml-auto icon-download-certificate"
              v-if="isCertificate(item)"
            >
              <img
                title="Fazer download do certificado"
                class="custom-img"
                :class="
                  !onCheckDownloadCertificate(item, $props.steps[index - 1]) &&
                  'custom-disabled'
                "
                @click="
                  onCheckDownloadCertificate(item, $props.steps[index - 1]) &&
                    onDownloadCertificate(item)
                "
                :src="resolve_path_url('download-pencil-outline.svg')"
              />
            </div>
          </div>
          <b-collapse
            :id="'collapse-content-' + item.id"
            :visible="$props.currentStep && $props.currentStep.id == item.id"
            class="d-lg-none"
          >
            <div v-if="item.type == 'VIDEO'">
              <Video
                :item="item"
                :onNextStep="$props.onNextStep"
                :onFinishedStep="$props.onFinishedStep"
                :onStartStep="$props.onStartStep"
              />
            </div>
            <div v-if="item.type == 'PDF'">
              <Pdf
                :item="item"
                :training="$props.item"
                :onNextStep="$props.onNextStep"
                :onFinishedStep="$props.onFinishedStep"
                :onStartStep="$props.onStartStep"
              />
            </div>
            <div v-if="item.type == 'FORM'">
              <Form
                :item="item"
                :onNextStep="$props.onNextStep"
                :onFinishedStep="$props.onFinishedStep"
                :onStartStep="$props.onStartStep"
              />
            </div>
            <div v-if="item.type == 'CERTIFICATE'">
              <Certificate
                :item="item"
                :onNextStep="$props.onNextStep"
                :onFinishedStep="$props.onFinishedStep"
                :onStartStep="$props.onStartStep"
              />
            </div>
          </b-collapse>
          <div
            v-if="getFilesAdditionalNoPrincial(item.filesAdditional).length > 0"
            class="custom-files-additional pb-3"
          >
            <div class="effect-line-left">
              <hr />
              <div
                v-for="(file, fileIndex) in getFilesAdditionalNoPrincial(
                  item.filesAdditional
                )"
                :key="id + index + fileIndex"
              >
                <div
                  class="align-items-center step-file"
                  @click="
                    !isDisabled(item, $props.steps[index - 1]) &&
                      onDownload(file)
                  "
                  :class="
                    !isDisabled(item, $props.steps[index - 1]) && 'cursor-point'
                  "
                >
                  <p
                    v-text="
                      truncatedText(
                        file.fileName
                          ? file.fileName
                          : 'file-' + (fileIndex + 1)
                      )
                    "
                    :class="
                      isDisabled(item, $props.steps[index - 1]) &&
                      'custom-disabled'
                    "
                    class="text-file pr-1"
                  ></p>

                  <img
                    class="adicional-custom-img"
                    :class="
                      isDisabled(item, $props.steps[index - 1])
                        ? 'custom-disabled'
                        : 'cursor-point'
                    "
                    :src="resolve_path_url('download-pencil-outline-green.svg')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </CustomAccordionButton>
</template>

<script>
import { truncatedText } from "../../../utils/format/formtUtils";
import {
  anchorBase64DownloadWithAtob,
  anchorBase64Download,
} from "../../../utils/anchor-base64-download/anchor-base64-download";
import { createToast } from "../../../components/toast/toast";
import {
  downloadCertificate,
  getDocument,
} from "../../../services/training/trainingService.js";
import CustomAccordionButton from "../../../components/custom-accordion/CustomAccordionButton.vue";
import { resolve_path_url } from "../../../utils/image/image-utils";
import Period from "../components/period.vue";
import Video from "./video.vue";
import Pdf from "./pdf.vue";
import Form from "./form.vue";
import Certificate from "./certificate.vue";
import { getMimeTypeByExtension } from "../../../utils/File/mimeType";

export default {
  components: {
    CustomAccordionButton,
    Period,
    Video,
    Pdf,
    Form,
    Certificate,
  },
  props: [
    "title",
    "status",
    "steps",
    "onStepClick",
    "currentStep",
    "id",
    "onTrainingClick",
    "item",
    "onNextStep",
    "onFinishedStep",
    "onStartStep",
  ],
  data() {
    return {
      loading: false,
      icons: {
        VIDEO: {
          enabled: "MDI-motion-play.svg",
          disabled: "MDI-motion-play-disabled.svg",
          pendingDisabled: false,
        },
        PDF: {
          enabled: "MDI-pdf.svg",
          disabled: "MDI-pdf-disabled.svg",
          pendingDisabled: true,
        },
        FORM: {
          enabled: "MDI-message-question.svg",
          disabled: "MDI-message-question-disabled.svg",
          pendingDisabled: true,
        },
        CERTIFICATE: {
          enabled: "MDI-certificate.svg",
          disabled: "MDI-certificate-disabled.svg",
          pendingDisabled: true,
        },
      },
    };
  },
  methods: {
    getFileExtension(filename) {
      return filename.split(".").pop();
    },
    truncatedText(fullName) {
      let name = fullName.split(".").shift();
      return truncatedText(name, 25) + "." + this.getFileExtension(fullName);
    },
    getFilesAdditionalNoPrincial(filesAdditional) {
      if (filesAdditional.length > 0) {
        return filesAdditional.filter((fa) => !fa.principal);
      }
      return [];
    },
    onCheckDownload(item) {
      return (
        item.type == "PDF" ||
        (item.filesAdditional != null &&
          item.filesAdditional != undefined &&
          item.filesAdditional.length > 0)
      );
    },
    isCertificate(item) {
      return item.type == "CERTIFICATE";
    },
    onCheckDownloadCertificate(item, beforeStep) {
      return (
        item.type == "CERTIFICATE" &&
        item.certificateToDownload &&
        beforeStep.status == "FINISHED"
      );
    },
    isDisabled(item, beforeStep) {
      return !(item.order == 0 || beforeStep?.status == "FINISHED");
    },
    getClassToPending(item, beforeStep) {
      let classCss = "";
      if (this.$props.currentStep?.id == item.id) {
        classCss += " effect ";
      }

      if (
        item.order == 0 ||
        beforeStep?.status == "FINISHED" ||
        this.$store.getters.isAdmin
      ) {
        classCss += " cursor-point ";
      }

      return classCss;
    },
    getPathUrl(item, beforeStep) {
      if (this.$store.getters.isAdmin) {
        return resolve_path_url(this.icons[item.type].disabled);
      }
      return item.order == 0 || beforeStep?.status == "FINISHED"
        ? resolve_path_url(this.icons[item.type].enabled)
        : resolve_path_url(this.icons[item.type].disabled);
    },
    onClick(step) {
      this.$props.onStepClick(step, this.$props.steps);
    },
    getLink(link) {
      if (this.$store.getters.isApp) {
        return link.replace("https", "http");
      } else {
        return link;
      }
    },
    async onDownloadCertificate(item) {
      this.loading = true;
      try {
        const response = await downloadCertificate(item.idTraining);

        if (!response.fileBase64) {
          createToast(
            "Informação",
            "Seu certificado ainda não está disponível! Aguarde, em breve disponibilizaremos para você.",
            "info"
          );
          this.loading = false;
          return;
        }

        const fileBase64 = response.fileBase64;
        const fileName = response.fileName;
        const extension = response.extension;

        anchorBase64Download(
          this.$store.getters.isApp,
          "application/pdf",
          fileName + extension,
          fileBase64
        );
      } catch (error) {
        createToast("Erro", "Não foi possível baixar o certificado.");
        console.error(
          "Error onDownloadCertificate: error ao baixar o certificado",
          error
        );
        this.loading = false;
      }

      this.loading = false;
    },
    async onDownloadFile(item) {
      const base64Data = await getDocument(item.link, item.fileName);

      const fileExtension = item.fileName
        ? item.fileName.split(".").pop().toLowerCase()
        : "pdf";
      const mimeType =
        getMimeTypeByExtension(fileExtension) || "application/pdf";
      const fileNameWithExtension = item.fileName || `file.${fileExtension}`;

      if (this.$store.getters.isApp) {
        anchorBase64Download(
          false,
          mimeType,
          fileNameWithExtension,
          base64Data.documentBase64
        );
      } else {
        // Use the anchorBase64Download utility for base64 data
        anchorBase64DownloadWithAtob(
          mimeType,
          fileNameWithExtension,
          base64Data.documentBase64
        );
      }
    },
    onDownload(item) {
      if (item.type == "PDF") {
        if (item?.status != "FINISHED") return;
        this.onDownloadFile(item);
      } else {
        this.onDownloadFile(item);
      }
    },
    onDownloadPrincipal(item) {
      if (item.filesAdditional.length > 0) {
        var file = item.filesAdditional.filter((fa) => fa.principal)[0];
        this.onDownloadFile(file);
      }
    },
    resolve_path_url: resolve_path_url,
  },
};
</script>
<style lang="scss" scoped>
.component-training {
  margin-bottom: 1em;
}
.cursor-point {
  cursor: pointer;
}
.title {
  padding-left: 1rem;
  font-size: 1.6rem;
}
.custom-step-menu {
  border-top-width: 0.5px;
  border-top-style: solid;
  border-top-color: #cdd2d7;

  padding-left: 1rem;
  display: grid;
  width: 100%;
  height: 4.4rem;
  padding-right: 0;
  grid-template-columns: 35px auto;
}
.cursor-point {
  cursor: pointer;
}
.effect {
  border-right-width: 3px;
  border-right-style: solid;
  border-right-color: #b1d34b !important;
}
.step-title {
  display: flex;
  flex-flow: row wrap;
  margin-left: 30px;
  padding-top: 12px;
  padding-bottom: 12px;
}

.step-file {
  display: flex;
  flex-flow: row wrap;
  padding-top: 5px;
}

.effect-line-left {
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: #aaaaaa36 !important;
  margin: 0px 0 0 0;
  padding-left: 20px;
}

.custom-img {
  height: 2.2rem;
  width: 2.2rem;
}
.adicional-custom-img {
  color: var(--primary);
  height: 1.2rem;
  width: 1.2rem;
}
hr {
  border-color: #aaaaaa36;
  box-sizing: border-box;
  width: 100%;
  margin: 0px 0 0 0;
}
.selected {
  border-right-width: 3px;
  border-right-style: solid;
  border-right-color: #b1d34b !important;
}

.icon-download-pdf,
.icon-download-certificate {
  margin-right: 20px;
}

.text-file {
  font-size: multiplier-default-font-size(1);
  color: var(--primary);
  text-decoration: underline;
  line-break: anywhere;
}

.custom-files-additional {
  padding-left: 42px;
}
.custom-disabled {
  opacity: 0.5;
}
.maiusculo {
  text-transform: uppercase;
}
</style>
